module.exports = __webpack_public_path__ + "static/media/icon.801f90b5.png";